export const Z_INDEX = {
  base: 1,
  dropdown: 10,
  sticky: 20,
  navbar: 500,
  sidebar: 100,
  modal: 1000,
  tooltip: 2000,
};

export const AREA_UNITS = ["sqft", "sqm", "sqyd", "acre", "hect"];

export const INITIAL_LOCATION = {
  type: "Point",
  coordinates: [],
  address: {
    formatted: "",
    street: "",
    locality: "",
    city: "",
    state: "",
    country: "India",
    pincode: "",
  },
};

export const INITIAL_AREA = {
  value: "",
  unit: "sqft.",
};
